import { makeStyles } from '@material-ui/core';
import Spin from 'components/Spin';
import React from 'react';
import { useObservable } from 'react-use-observable';
import useWidth from 'v2/hooks/useWidth';
import tableService from 'v2/services/table';

const useStyles = makeStyles(() => ({
  emptyMessage: {
    textAlign: 'center',
    paddingTop: 20,
  },
}));

interface IProps {
  colSpan: number;
}

const MyTableLoading = ({ colSpan }: IProps) => {
  const width = useWidth();
  const classes = useStyles({});
  const [isLoading] = useObservable(() => tableService.isLoading(), []);

  if (!isLoading) return null;

  if (width === 'md' || width === 'lg' || width === 'xl') {
    return (
      <tr data-testid='table-loading'>
        <td colSpan={colSpan} className={classes.emptyMessage}>
          <Spin />
        </td>
      </tr>
    );
  }

  return (
    <div data-testid='table-loading'>
      <Spin />
    </div>
  );
};

export default MyTableLoading;
